const countriesWhoUseImperialUnits = ["US", "MM", "LR"] as readonly string[]

export const getCountryUsesImperialUnits = (countryCode: string): boolean => {
  return countriesWhoUseImperialUnits.includes(countryCode)
}
